import { createContext, useContext, useState } from "react";

// Create the context
const SideSheetContext = createContext();

export const SideSheetProvider = ({ children }) => {
  // Default state for modal
  const [sheetState, setSheetState] = useState({
    isOpen: false,
    ContentComponent: null,
    contentProps: {},
  });

  const openSheet = (ContentComponent, contentProps = {}) => {
    setSheetState({
      isOpen: true,
      ContentComponent,
      contentProps,
    });
  };

  // Function to close the sheet and reset state
  const closeSheet = () => {
    setSheetState({
      ...sheetState, // Probs useless here
      isOpen: false,
      ContentComponent: null,
      contentProps: {},
    });
  };

  return (
    <SideSheetContext.Provider value={{ ...sheetState, openSheet, closeSheet }}>
      {children}
      <BasicSheet />
    </SideSheetContext.Provider>
  );
};

const BasicSheet = () => {
  const { isOpen, ContentComponent, contentProps } = useSheet();

  // Don't render if sheet is closed or no content is provided
  if (!isOpen || !ContentComponent) return null;

  return (
    <div className="sidebar sidebar-sm sidebar-reset">
      <ContentComponent {...contentProps} />
    </div>
  );
};

// Hook to access the sheet context
export const useSheet = () => {
  const context = useContext(SideSheetContext);
  if (!context) {
    throw new Error("useSheet must be used within a SideSheetProvider");
  }
  return context;
};
